module.exports = __webpack_public_path__ + "img/games-10.d81c3e54.jpg";